import React from 'react';
import PropTypes from 'prop-types';
import { DateTimeService } from '@shared/services/DateTimeService';
import styled from 'styled-components';
import Btn from '../buttons/Btn';
import MeetingsForm from './MeetingsForm';
import { FONT_FAMILY_MAIN, LINKS_COLOR, TEXT_COLOR } from '../../theme';
import { HelpText } from './HelpText';

const FormHeader = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 16px;
`;

const ChoosedDateContainer = styled.div`
  flex: 1;
`;

const ChoosedDateTitle = styled.div`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 16px;
  font-weight: 800;
  line-height: 1.38;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
  margin-bottom: 2px;
`;

const ChoosedDate = styled.div`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 16px;
  line-height: 1.19;
  letter-spacing: -0.1px;
  color: ${TEXT_COLOR};
`;

const HelpLink = styled(HelpText)`
  display: inherit;
  color: ${LINKS_COLOR};
  margin-top: 0;
`;

export const FormStep = ({
  currentTime,
  cachedUser,
  isFormSubmitting,
  meetingSubjects,
  toBackStep,
  onFormSubmit,
  timeZone,
  bookableMeetingKinds,
  isMessageAllowed,
}) => (
  <>
    <FormHeader>
      <ChoosedDateContainer>
        <ChoosedDateTitle>Date du rendez-vous</ChoosedDateTitle>
        <ChoosedDate>
          {DateTimeService.formatInTimeZone(
            new Date(currentTime),
            timeZone,
            "EEEE d MMMM 'à' HH:mm"
          )}
        </ChoosedDate>
      </ChoosedDateContainer>
      <Btn text="Modifier" outlined small onClick={toBackStep} />
    </FormHeader>
    <MeetingsForm
      meetingSubjects={meetingSubjects}
      cachedUser={cachedUser}
      onFormSubmit={onFormSubmit}
      isSending={isFormSubmitting}
      bookableMeetingKinds={bookableMeetingKinds}
      isMessageAllowed={isMessageAllowed}
    />
    <HelpText align="left">
      Votre demande et vos coordonnées seront transmises à l’auto-école. Pour plus d’informations,
      consultez notre&nbsp;
    </HelpText>
    <HelpLink
      as="a"
      href="/a-propos/donnees-personnelles"
      target="_blank"
      rel="noopener noreferrer"
    >
      Politique de protection des données personnelles.
    </HelpLink>
  </>
);

FormStep.propTypes = {
  currentTime: PropTypes.string.isRequired,
  cachedUser: PropTypes.object,
  isFormSubmitting: PropTypes.bool.isRequired,
  meetingSubjects: PropTypes.array.isRequired,
  toBackStep: PropTypes.func.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  timeZone: PropTypes.string.isRequired,
  bookableMeetingKinds: PropTypes.array.isRequired,
  isMessageAllowed: PropTypes.bool,
};

FormStep.defaultProps = {
  cachedUser: null,
  isMessageAllowed: false,
};
